import { Track as Track$1 } from '@hugendubel/tracking_client';
export { TRACK_ID } from '@hugendubel/tracking_client';
import { _ } from '@hugendubel/utils';
import { Track as Track$2 } from '@hugendubel/gtm_client';
import { Emarsys } from '@hugendubel/emarsys_client';
import { Prudsys } from '@hugendubel/prudsys';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var info = function (trackId, message) {
    Track$1.info(trackId, message);
};
var error = function (trackId, message) {
    Track$1.error(trackId, message);
};
var submitSuccess = function (trackId) {
    Track$1.submitSuccess(trackId);
};
var submitError = function (trackId, validationError, error) {
    Track$1.submitError(trackId, validationError, error);
};
var navigation = function (trackId, type, action, target) {
    Track$1.navigation(trackId, type, action, target);
};
var selection = function (trackId, optionNamesOrLength, choiceIndex) {
    Track$1.selection(trackId, optionNamesOrLength, choiceIndex);
};
// since in some situations we have to wait for the tracking
// (e.g. directly afterwards the user wants to navigate to another page and hence pending requests would be cancelled)
// we want to set maximum time we want to wait before proceeding to navigate
var MAX_BLOCKING_TIME = 200;
var _race = function (trackingFn) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return Promise.race([trackingFn.apply(void 0, args), _.sleep(MAX_BLOCKING_TIME)]);
    });
};
var recommendationClick = _race(Prudsys.Dispatcher.click);
var article = _race(function (trackId, article, amount, action, source, target, error, index, rating) {
    Track$1.article(trackId, article, amount, action, source, target, error, index, rating);
    if (!error && (target === 'BASKET' || target === 'QUICK_BUY')) {
        if (action === 'ADD' || (action === 'EDIT' && amount > 0)) {
            Track$2.eCommerceAddToBasket([__assign(__assign({}, article), { amount: amount })]);
            // we track the Prudsys basket event only for positive amount changes
            var articleId = article.articleId;
            return Prudsys.Dispatcher.basket([{ articleId: articleId, amount: amount }]);
        }
        else if (action === 'REMOVE' || (action === 'EDIT' && amount < 0)) {
            Track$2.eCommerceRemoveFromBasket([__assign(__assign({}, article), { amount: amount })]);
        }
    }
    return Promise.resolve();
});
var viewArticle = function (trackId, article, source) {
    Track$1.article(trackId, article, 1, 'VIEW', source, 'AVA');
    Track$2.articleView(article);
};
var pageView = function (url, pagePath, pageTitle) {
    Track$2.pageView(url, pagePath, pageTitle);
};
var magazineView = function (url, breadcrumb) {
    Track$2.magazineView(url, breadcrumb);
};
var search = function (searchTerm, searchTermCorrection, resultCount) {
    Track$2.search({ searchTerm: searchTerm, searchTermCorrection: searchTermCorrection, resultCount: resultCount });
};
var suggest = function (suggestSearchTerm, resultCountAuthors, resultCountCategory, resultCountTitle, resultCountTop) {
    Track$2.suggest({ suggestSearchTerm: suggestSearchTerm, resultCountAuthors: resultCountAuthors, resultCountCategory: resultCountCategory, resultCountTitle: resultCountTitle, resultCountTop: resultCountTop });
};
var resetDataLayer = function () {
    Track$2.resetDataLayer();
};
var loggedInCustomer = function (trackId, _a) {
    var myshopFlag = _a.myshopFlag, hashId = _a.hashId;
    Emarsys.loggedInCustomer({ hashId: hashId, myshopFlag: myshopFlag });
};
var loggedOutCustomer = function (trackId) {
    Track$2.loggedOutCustomer();
};
var _trackedGiftWrapCosts = function (_a) {
    var giftWrap = _a.giftWrap, giftWrapCosts = _a.giftWrapCosts;
    return giftWrap && giftWrap.active ? giftWrapCosts : undefined;
};
var _trackedCheckoutData = function (checkoutData) { return (__assign(__assign({}, checkoutData), { giftWrapCosts: _trackedGiftWrapCosts(checkoutData) })); };
var _trackedOrder = function (order) { return (__assign(__assign({}, order), { giftWrapCosts: _trackedGiftWrapCosts(order) })); };
var checkout = function (trackId, checkoutData, step, error) {
    Track$1.order(trackId, 'REVIEW', _trackedCheckoutData(checkoutData), error);
    if (!error) {
        Track$2.basketDisplayed(checkoutData);
        Track$2.eCommerceCheckout(step, checkoutData);
    }
};
var checkoutStep = function (trackId, step) {
    Track$2.eCommerceCheckout(step);
};
var orderFailed = function (trackId, checkoutData, error) {
    Track$1.order(trackId, 'BUY', _trackedCheckoutData(checkoutData), error);
};
var order = _race(function (trackId, order, newCustomerFlag) {
    Track$1.order(trackId, 'BUY', _trackedOrder(order));
    Track$2.basketBuy(order, newCustomerFlag);
    Track$2.eCommercePurchase(order);
    return Prudsys.Dispatcher.order(order.items.map(function (_a) {
        var amount = _a.amount, price = _a.price, articleId = _a.articleId;
        return ({
            amount: amount || 0,
            price: price || 0,
            articleId: articleId,
        });
    }));
});
var confirm = function (trackId, order) {
    Track$1.order(trackId, 'CONFIRM', _trackedOrder(order));
};
// ====================================================
// ============ End of Checkout Tracking ==============
// ====================================================
var Track = {
    WS: Track$1,
    GTM: Track$2,
    EMARSYS: Emarsys,
    error: error,
    submitError: submitError,
    submitSuccess: submitSuccess,
    navigation: navigation,
    info: info,
    selection: selection,
    recommendationClick: recommendationClick,
    article: article,
    pageView: pageView,
    magazineView: magazineView,
    resetDataLayer: resetDataLayer,
    search: search,
    suggest: suggest,
    loggedInCustomer: loggedInCustomer,
    loggedOutCustomer: loggedOutCustomer,
    checkout: checkout,
    checkoutStep: checkoutStep,
    order: order,
    orderFailed: orderFailed,
    confirm: confirm,
    viewArticle: viewArticle,
};

export { Track };
